import { __decorate } from "tslib";
import { action, computed, observable, runInAction } from 'mobx';
import { ROW_GROUP_HEIGHT } from './TableRowGroup';
export default class VirtualRowMetaData {
    constructor(store, type, prev, record) {
        this.store = store;
        this.type = type;
        this.prev = prev;
        if (record !== undefined) {
            runInAction(() => {
                this.record = record;
            });
        }
    }
    get height() {
        if (this.type === 'group') {
            return ROW_GROUP_HEIGHT;
        }
        const { actualHeight } = this;
        if (actualHeight === undefined) {
            return this.store.virtualRowHeight;
        }
        return actualHeight;
    }
    get offset() {
        const { prev } = this;
        if (prev) {
            return prev.offset + prev.height;
        }
        return 0;
    }
    setHeight(height) {
        this.actualHeight = height;
        this.aggregation = this.store.aggregation;
    }
}
__decorate([
    observable
], VirtualRowMetaData.prototype, "actualHeight", void 0);
__decorate([
    observable
], VirtualRowMetaData.prototype, "record", void 0);
__decorate([
    computed
], VirtualRowMetaData.prototype, "offset", null);
__decorate([
    action
], VirtualRowMetaData.prototype, "setHeight", null);
